/* Libs */
import create from 'zustand';

/* Model */
import Categories from 'Models/Categories';

const [useCategoriesStore] = create(set => ({
	categories: null,
	fetchCategories: async () => {
		const response = await Categories.get();
		console.log('set categories', response);

		set({ categories: response });
	}
}));

export default useCategoriesStore;
